import React, { useState, useEffect } from "react";
import { useGetSellerQuery } from "../redux/apislice";
import { format } from 'date-fns';
import { Player } from "@lottiefiles/react-lottie-player";


function AddCategory() {
  const { data, isLoading } = useGetSellerQuery();
  const [user, setUser] = useState(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profilePic, setProfilePic] = useState(null);
  

  useEffect(() => {
    if (data?.data) {
      const sellerData = {
        name: data.data.name,
        email: data.data.email,
        profilePic: data.data.image || "https://i.pravatar.cc/150?img=3",
        kyc: {
          cnic: "35201-1234567-8",
          dob: data.data.dob?.split("T")[0],
          address: "Gujrat, Pakistan",
        },
      };
      setUser(sellerData);
      setProfilePic(sellerData.profilePic); 
    }
  }, [data]);

  const handlePasswordChange = () => {
    if (!currentPassword) {
      alert("❌ Please enter your current password");
      return;
    }
    if (password.length < 8) {
      alert("❌ Password must be at least 8 characters long");
      return;
    }
    if (password !== confirmPassword) {
      alert("❌ Passwords do not match");
      return;
    }
    console.log("Password change request:", { currentPassword, newPassword: password });
    alert("Password changed (demo only)");
    setCurrentPassword("");
    setPassword("");
    setConfirmPassword("");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfilePic(imageUrl);
      alert("Image updated (not saved in backend)");
    }
  };

  // if (isLoading || !user) return <div className="p-8 text-gray-600">Loading...</div>;
  
if (isLoading || !user) {
      return (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            // backgroundColor: 'white'
          }}>
        <Player
              autoplay
              loop
              src="https://assets1.lottiefiles.com/packages/lf20_raiw2hpe.json"
              style={{ height: '150px', width: '150px' }}
            />
          </div>
        );
      }
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-gray-50 to-white p-4 sm:p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">Account Settings</h1>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Profile Info</h2>

          <div className="flex flex-col items-center gap-4">
            <img
              src={profilePic}
              alt="Profile"
              className="w-28 h-28 rounded-full object-cover border-4 border-black"
            />
            <div className="w-full">
              <label className="block mb-2 font-medium text-gray-700">Change Profile Picture</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="text-sm text-gray-600 w-full"
              />
            </div>
          </div>

          <div className="mt-6 grid sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Seller Badge</label>
              <span className="mt-1 inline-block px-3 py-1 text-sm rounded-full bg-yellow-100 text-yellow-800">
                Top Rated Seller
              </span>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Store Location</label>
              <span className="block mt-1 text-gray-800">Gujrat, Pakistan</span>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Account Status</label>
              <span className="block mt-1 px-2 py-1 bg-green-100 text-green-700 rounded-full text-sm">
                Active
              </span>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Total Products Listed</label>
              <span className="block mt-1 text-gray-800 font-semibold">45 for testing only</span>
            </div>
           
          </div>
           <div className="flex items-center space-x-4 space-y-4">
  <label className="block text-sm mt-4 font-medium text-gray-700">Your Store URL:</label>
  <a
    href={`https://khushhali.com/store/${data?.data?.storename}`}
    target="_blank"
    rel="noreferrer"
    className="text-blue-600 items-center hover:underline  block"
  >
    {`https://khushhali.com/store/${data?.data?.storename}`}
  </a>
</div>
           <div className="flex items-center space-x-4 space-y-4">
              <label className="block text-sm mt-4 font-medium text-gray-700">Member Since:</label>
              <span className="block mt-1 text-gray-800">August 2025 </span>
            </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Basic Information</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Full Name</label>
              <input
                type="text"
                value={user.name}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                value={user?.email}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Phone Number</label>
              <input
                type="text"
                value={data?.data?.phone}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Store Name</label>
              <input
                type="text"
                value={data?.data?.storename}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Account Type</label>
              <input
                type="text"
                value={data?.data?.accountType}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Gender</label>
              <input
                type="text"
                value={data?.data?.gender}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Date of Birth</label>
              <input
                type="text"
                value={user.kyc.dob}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div className="sm:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Address</label>
              <input
                type="text"
                value={user.kyc.address}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
  <label className="block text-sm font-medium text-gray-700">Created</label>
  <input
    type="text"
    value={data?.data?.created ? format(new Date(data.data.created), 'MMMM d, yyyy h:mm a') : ''}
    disabled
    className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
  />
</div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Updated</label>
              <input
                type="text"
                value={data?.data?.updated ? format(new Date(data.data.updated), 'MMMM d, yyyy h:mm a') : ''}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div className="sm:col-span-2">
              <label className="block text-sm font-medium text-gray-700">Tax ID / NTN</label>
              <input
                type="text"
                value="1234567-9"
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                value={user.email}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Limit</label>
              <input
                type="text"
                value={data?.data?.limit}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <input
                type="text"
                value={data?.data?.status}
                disabled
                className="mt-1 w-full bg-gray-100 text-gray-700 px-3 py-2 rounded border"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 col-span-1 lg:col-span-2">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Change Password</h2>

          <div className="flex flex-col gap-4">
            <div className="flex flex-col">
              <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Enter current password"
                className="border border-gray-300 rounded px-4 py-2"
              />
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1 flex flex-col">
                <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter new password"
                  className="border border-gray-300 rounded px-4 py-2"
                />
              </div>
              <div className="flex-1 flex flex-col">
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  className="border border-gray-300 rounded px-4 py-2"
                />
              </div>
            </div>

            <div className="text-xs text-gray-500">
              Password must be at least 8 characters long
            </div>

            <button
              onClick={handlePasswordChange}
              className="self-start bg-black text-white px-6 py-2 rounded hover:bg-gray-800"
            >
              Update Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCategory;